export default __webpack_public_path__ + "static/media/burger_menu.18141107.svg";